/* eslint-disable import/prefer-default-export */

import {
  SET_CURRENT_USER,
  DELETE_CURRENT_USER
} from "../constants/authConstants";

export const setCurrentUser = user => ({
  type: SET_CURRENT_USER,
  payload: user
});

export const deleteCurrentUser = () => ({
  type: DELETE_CURRENT_USER
});
